import { styled } from '@linaria/react';
import { cssTheme } from '@daedalus/atlas/themes';
export const DIVIDER_WIDTH = 1;
export const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i12x9qvo",
  propsAsIs: false
});
export const formButtonFocusBorderStyles = `
  border-color: ${cssTheme.colors.border.interactive.c800} !important;
  box-shadow: 0px 0px 0px 1px ${cssTheme.colors.border.interactive.c800} !important;
`;
export const formButtonFocusIconStyles = `
  color: ${cssTheme.colors.content.interactive.c800} !important;
`;

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.tsx");